import Action from '../../actions/userObject'
import { ICountry } from '../../models/Country'
import { ICurrency } from '../../models/Currency'
import { IProfile, ISettings } from '../../models/Object'
import { IObjectType } from '../../models/ObjectType'
import { AuthorizationActions } from '../userAccount/actionNames'
import {
  CountryDictionary,
  DateTimeFormatActions,
  ObjectType,
  UserObjectActions,
  UserProfileActions,
  UserSettingsActions,
} from './actionNames'
import initialStore from './initialState'
import changeObjectId from './mutators/changeObjectId'
import dictionaryAccepted from './mutators/dictionaryAccepted'
import objectAccepted from './mutators/objectAccepted'
import requestDataForObject from './mutators/requestDataForObject'
import requestDataForUserSettings from './mutators/requestDataForUserSettings'
import requestObjectAccepted from './mutators/requestObjectAccepted'
import requestObjectRejected from './mutators/requestObjectRejected'
import requestSaveObject from './mutators/requestSaveObject'
import requestSaveObjectAccepted from './mutators/requestSaveObjectAccepted'
import requestUpdateUserSettings from './mutators/requestUpdateUserSettings'
import requestDeleteLogo from './mutators/logoWasDeleted'
import requestUpdateLogo from './mutators/requestUpdateLogo'
import userSettingsAccepted from './mutators/userSettingsAccepted'
import userSettingsDateTime from './mutators/userSettingsDateTime'
import userSettingsRejected from './mutators/userSettingsRejected'
import userSettingsUpdated from './mutators/userSettingsUpdated'
import { ITags } from './tags'

export default function(
  store: Readonly<IUserObjectStore> = initialStore,
  action: Action & any,
): IUserObjectStore {
  switch (action.type) {
    case UserObjectActions.ChangeUserObjectId:
      return changeObjectId(store, action)

    case UserProfileActions.RequestDataForUserProfile:
      return requestDataForObject(store)
    case UserProfileActions.DataForUserProfileAccepted:
      return requestObjectAccepted(store, action)
    case UserProfileActions.DataForUserProfileRejected:
      return requestObjectRejected(store, action)

    case UserProfileActions.RequestSaveObject:
      return requestSaveObject(store)
    case UserProfileActions.UpdatingUserProfileIsAccepted:
      return requestSaveObjectAccepted(store)

    case UserProfileActions.RequestDeleteUserProfileLogo:
      return requestDeleteLogo(store)
    case UserProfileActions.RequestUpdateUserProfileLogoAccepted:
      return requestUpdateLogo(store, action)

    case UserSettingsActions.RequestDataForUserSettings:
      return requestDataForUserSettings(store)
    case UserSettingsActions.DataForUserSettingsAccepted:
      return userSettingsAccepted(store, action)
    case UserSettingsActions.DataForUserSettingsRejected:
      return userSettingsRejected(store, action)

    case UserSettingsActions.RequestUpdateForUserSettings:
      return requestUpdateUserSettings(store)
    case UserSettingsActions.SettingsUpdateAccepted:
      return userSettingsUpdated(store, action)

    case DateTimeFormatActions.ChangeDateTimeFormatValues:
      return userSettingsDateTime(store, action)

    case CountryDictionary.DictionaryAccepted:
      return dictionaryAccepted(store, action)

    case ObjectType.ObjectAccepted:
      return objectAccepted(store, action)
    case UserProfileActions.UpdateUserCurrency:
      return {
        ...store,
        userObject: {
          ...store.userObject,
          profile: {
            ...store.userObject.profile,
            idCurrency: action.payload,
          },
        },
      }
    case UserObjectActions.NewPriceListActivated:
      return {
        ...store,
        userObject: {
          ...store.userObject,
          profile: { ...store.userObject.profile, pricelistVersion: '2' },
        },
      }

    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }
  return store
}

export interface IUserObjectStore {
  userObjectId?: number
  userObject?: {
    profile?: IProfile
    settings?: ISettings
  }

  profileRequest: IRequestDetails
  settingsRequest: IRequestDetails
  financeRequest: IRequestDetails

  currency: ICurrency[]
  countryDictionary: ICountry[]
  objectType: IObjectType[]
  tags: ITags
}

export interface IRequestDetails {
  isLoading: boolean
  isSaving: boolean
  errMessage: string
  acceptedCount: number
}
